import { render, staticRenderFns } from "./RequestAnamnesis.vue?vue&type=template&id=c75f9f3e&scoped=true"
import script from "./RequestAnamnesis.vue?vue&type=script&lang=js"
export * from "./RequestAnamnesis.vue?vue&type=script&lang=js"
import style0 from "./RequestAnamnesis.vue?vue&type=style&index=0&id=c75f9f3e&prod&lang=scss"
import style1 from "./RequestAnamnesis.vue?vue&type=style&index=1&id=c75f9f3e&prod&lang=scss&scoped=true"
import style2 from "./RequestAnamnesis.vue?vue&type=style&index=2&id=c75f9f3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75f9f3e",
  null
  
)

export default component.exports